<template>
  <Tooltip v-if="hasWarning" class="expired-indicator-tooltip attention-tooltip" nameIcon="error" @click.stop>
    Имеются показатели, по которым истек срок обновления
  </Tooltip>
</template>

<script>
  import expiredIndicatorItem from '@/common/mixins/expiredIndicatorItem';
  import Tooltip from '@/common/ui/Tooltip.vue';

  export default {
    name: 'ExpiredIndicatorTooltip',
    components: { Tooltip },
    mixins: [expiredIndicatorItem],
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/colors.scss';

  :deep(.attention-tooltip) {
    &.v-popper--shown svg rect,
    .tooltip-component__icon:hover svg rect {
      stroke: none !important;
      fill: $colorRed;
    }
  }
</style>
